export const expectedDelivery = (days: number) => {
    const day = new Date();
    for (let i = 0; i < days; ++i) {
        if (day.getDay() == 6) {
            day.setDate(day.getDate() + 3);
        } else if (day.getDay() == 0) {
            day.setDate(day.getDate() + 2);
        } else {
            day.setDate(day.getDate() + 1);
        }
    }

    if (day.getDay() == 6) {
        day.setDate(day.getDate() + 2);
    } else if (day.getDay() == 0) {
        day.setDate(day.getDate() + 1);
    }

    let dayString = ''; //  TODO
    switch (day.getDay()) {
        case 0:
            dayString = 'v neděli';
            break;
        case 1:
            dayString = 'v pondělí';
            break;
        case 2:
            dayString = 'v úterý';
            break;
        case 3:
            dayString = 've středu';
            break;
        case 4:
            dayString = 've čtvrtek';
            break;
        case 5:
            dayString = 'v pátek';
            break;
        case 6:
            dayString = 'v sobotu';
            break;
        default:
            dayString = '';
    }

    return `${dayString} ${day.getDate()}/${day.getMonth() + 1}`;
};



// WEBPACK FOOTER //
// ./src/helpers/expectedDelivery.ts